.userCount {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 300;
  color: #969696;
}
